import styled from "styled-components";

export const ProfileWrapper = styled.div`
  height: 100%;
  width: 100%;
`;
